import { render, staticRenderFns } from "./RegistroUser.vue?vue&type=template&id=300323f4"
import script from "./RegistroUser.vue?vue&type=script&lang=js"
export * from "./RegistroUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('300323f4')) {
      api.createRecord('300323f4', component.options)
    } else {
      api.reload('300323f4', component.options)
    }
    module.hot.accept("./RegistroUser.vue?vue&type=template&id=300323f4", function () {
      api.rerender('300323f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizardUser/RegistroUser.vue"
export default component.exports